import styled from "styled-components"

const LinkCollectionContainer = styled.nav`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export default LinkCollectionContainer
